import axios from 'axios'
import getConfig from 'config/web'
import { getItem } from 'utils'

const { recruitmentServiceUrl: baseURL } = getConfig()

// authenticated

const token = getItem('token')
const instance = axios.create({
    baseURL,
    headers: {
        Authorization: `Bearer ${token}`,
        Pragma: 'no-cache',
    },
})

export const clientWithNoHeaders = axios.create({
    baseURL,
})

export default instance
